import { motion } from "framer-motion";
import { HERO_VIDEO, HERO_IMAGE } from "@/lib/data";
import { waLink } from "@/lib/whatsapp";
import { ArrowDown } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative h-screen w-full overflow-hidden bg-[#050505]"
    >
      {/* Cinematic background — real showreel video with still poster fallback */}
      <div className="absolute inset-0">
        <video
          src={HERO_VIDEO}
          poster={HERO_IMAGE}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          data-testid="hero-video"
          className="w-full h-full object-cover opacity-80"
        />
        {/* Layered gradient for text contrast */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/50 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full max-w-[1600px] mx-auto px-6 md:px-12 flex flex-col justify-end pb-24 md:pb-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: [0.65, 0, 0.35, 1] }}
          className="max-w-5xl"
        >
          <div className="flex items-center gap-3 mb-8">
            <span className="w-10 h-px bg-[#C4A484]" />
            <span className="font-mono-label text-[10px] text-[#C4A484]">
              India · Dubai · London
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-heading text-[13vw] md:text-[7.5vw] leading-[0.95] tracking-tighter text-[#FDFBF7]"
          >
            We turn a
            <br />
            <span className="italic text-[#C4A484]">12-hour wedding</span>
            <br />
            into a film your
            <br />
            family will watch
            <br />
            for decades.
          </h1>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 1 }}
            className="mt-10 md:mt-14 flex flex-col md:flex-row md:items-end gap-6 md:gap-16"
          >
            <p className="max-w-md text-[#FDFBF7]/70 text-sm md:text-base leading-relaxed">
              International wedding films for couples across India, the
              Emirates and the United Kingdom. Shot with intention by the
              Flyfilms team.
            </p>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta"
              className="font-mono-label text-[11px] px-8 py-4 border border-[#C4A484] text-[#C4A484] hover:bg-[#C4A484] hover:text-black transition-all duration-500 self-start"
            >
              Reserve Your Date →
            </a>
          </motion.div>
        </motion.div>

        {/* Scroll cue */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.6, duration: 1 }}
          className="absolute bottom-8 right-6 md:right-12 flex items-center gap-3 text-[#8F8F8F]"
        >
          <span className="font-mono-label text-[10px]">Scroll</span>
          <ArrowDown size={14} className="animate-bounce" />
        </motion.div>
      </div>
    </section>
  );
}
